import getStringAfterFirstDot from './get-string-after-first-dot';
const getKeysFromTemplate = template => {
  if (!template) return [];
  const matches = Array.from(template.matchAll(/{{\s?(#\w+\s+)?([\w\.]+)(\s+[\w\.]+)?\s?}}/gi));
  if (!matches.length) return [];
  return matches.flatMap(([match, blockHelper, key, arg]) => arg ? [getStringAfterFirstDot(key), getStringAfterFirstDot(arg.trim())] : [getStringAfterFirstDot(key)]).filter((key, index, matchedItem) => matchedItem.indexOf(key) === index).filter(Boolean);
};
export default getKeysFromTemplate;
//# sourceMappingURL=get-keys-from-template.js.map